import React from "react";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { connect } from "react-redux";

import * as Icon from "react-feather";
import { history } from "../../../history";
import Notification from "./../../../components/@self/Notification";
import userAvatar from "../../../assets/icons/userAvatar.jpg";

import { get } from "../../../utility/context/API";
import { logOut } from "../../../utility/context/API";
import { getDecryptedItem } from "../../../utility/encryptedStorage";
import { downloadFile } from "../../../utility/fileService";
import { useState } from "react";
import { useEffect } from "react";
import {useLocation} from 'react-router-dom'

const UserDropdown = (props) => {
  const loginData = JSON.parse(getDecryptedItem("data"));
  const [profile, setProfile] = useState();
  const location = useLocation();

  useEffect(() => {
    const processIcon = async () => {
      if (loginData?.profileIcon?.id) {
        try {
          const response = await downloadFile(loginData?.profileIcon);
          setProfile(response);
          if (props.setProfileImage) {
            props.setProfileImage(response || "");
          } 
        } catch (err) {
          console.log(err);
        }
      } else {
        setProfile("");
        if (props.setProfileImage) {
          props.setProfileImage("");
        }
      }
    };
    processIcon();
  }, [loginData, props.selectedUser]);

  const handleLogout = () => {
    logOut();
  };

  return (
    <DropdownMenu right>
      {location.pathname !== "/user-profile" && (
        <DropdownItem tag="a" onClick={() => history.push("/user-profile")}>
          <Icon.User size={14} className="mr-50" />
          <span className="align-middle">Edit Profile</span>
        </DropdownItem>
      )}

      {location.pathname !== "/change-passwd" && (
        <DropdownItem tag="a" onClick={() => history.push("/change-passwd")}>
          <Icon.Lock size={14} className="mr-50" />
          <span className="align-middle">Change Password</span>
        </DropdownItem>
      )}
      <DropdownItem divider />

      <DropdownItem tag="a" onClick={handleLogout}>
        <Icon.Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  );
};

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: [],
    profileImage: "",
  };

  setProfileImage = (img) => {
    this.setState({ profileImage: img });
  };

  componentDidMount() {
    get("/api/main-search/data").then(({ data }) => {
      this.setState({ suggestions: data.searchResult });
    });
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch,
    });
  };
  
  render() {
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        {/* <Notification /> */}
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {this.props.userName}
              </span>
              <span className="user-status">{this.props.company}</span>
            </div>
            <span data-tour="user">
              <img
                src={this.state.profileImage || userAvatar}
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span>
          </DropdownToggle>
          <UserDropdown
            {...this.props}
            setProfileImage={this.setProfileImage}
          />
        </UncontrolledDropdown>
      </ul>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedUser: state.userManagementReducer.selectedUser,
  };
};

export default connect(mapStateToProps, {})(NavbarUser);
